export const iconFontAwesomeCodingMugSaucer = (
	<i className="fa-solid fa-mug-saucer"></i>
);
